import { render, staticRenderFns } from "./apply_allot.vue?vue&type=template&id=a6731364&scoped=true"
import script from "./apply_allot.vue?vue&type=script&lang=js"
export * from "./apply_allot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6731364",
  null
  
)

export default component.exports